import { render, staticRenderFns } from "./FjBaseInput.vue?vue&type=template&id=82657724&"
import script from "./FjBaseInput.vue?vue&type=script&lang=js&"
export * from "./FjBaseInput.vue?vue&type=script&lang=js&"
import style0 from "./FjBaseInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
